import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {getInstanceIndex} from '@packages/systems/core/utils/NativeIdUtils';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {
  Plugins,
  withSystem,
  Atom,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TRecord, TBoolean} from '@packages/systems/wfdl-ast';
import {useRuntimeEnvironment} from '@packages/systems/render';

const {SSR, EXPORT} = WebflowEnvironments;

const ShippingMethodRadioButton = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    environmentContext,
  }: AtomRenderProps) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const checked = !(
      runtimeEnvironment === SSR || runtimeEnvironment === EXPORT
    )
      ? getInstanceIndex(environmentContext) === 0
      : false;
    return (
      <input
        {...generateAttributes(attributes, classes)}
        type="radio"
        name="shipping-method-choice"
        defaultChecked={checked}
      />
    );
  }
);

const staticBindings = Map({
  id: List([
    Map({
      slug: 'id',
      type: 'PlainText',
    }),
  ]),
  value: List([
    Map({
      slug: 'id',
      type: 'PlainText',
    }),
  ]),
  checked: List([
    Map({
      slug: 'selected',
      type: 'Bool',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Radio Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Radio')),
  },
  showEmpty: false,
  constraints: {
    ancestors: [{is: 'CommerceCheckoutShippingMethodItem', rule: 'ExactlyOne'}],
  },
  render: ShippingMethodRadioButton,
  staticBindings,
  fields: {
    attr: withSystem(
      {private: true},
      TRecord({
        required: TBoolean,
      })
    ),
  },
});

export default config;
